/* eslint-disable @typescript-eslint/no-explicit-any -- ItemsContainer injects loosely typed legacy handlers */
import { FunctionComponent } from "react";
import { ItemsContainer } from "containers/ItemsContainer";
import { ContainerItem } from "store";
import { TransportUnitCard } from "./TransportUnitCard";
import s from "./Loading.module.scss";

const LoadingTransportListView: FunctionComponent<any> = (props) => {
  const containers = props.groupData.containers as ContainerItem[];

  if (!containers.length) return null;

  return (
    <div className={s.list}>
      {containers.map((item: any) => (
        <TransportUnitCard
          key={item.uid}
          item={item}
          groups={props.groupData.groups}
          showMoveButtons={containers.length > 1}
          removeTransport={props.removeTransport}
          changeTransportIndex={props.changeTransportIndex}
          changeTransport={props.changeTransport}
          changeContainerCount={props.changeContainerCount}
          changeLoadingRules={props.changeLoadingRules}
          setAllowGroups={props.setAllowGroups}
          changeAllowGroups={props.changeAllowGroups}
        />
      ))}
    </div>
  );
};

export const LoadingTransportList = ItemsContainer(LoadingTransportListView);
